







import { Component, Vue } from 'vue-property-decorator'
import GeofenceList from '@/components/geofence/GeofenceList.vue'

@Component({
  components: {
    GeofenceList,
  },
})
export default class Geofences extends Vue {}
